import { post } from "../utils/backend";
import { Approval, ApprovalAuditRequest } from "../models/Approval";
import { AppConfigItem } from "../models/AppConfig";
import { AppConfigApi } from "./AppConfig";
import { mock } from "./mock/Mock";
import { getMockData } from "./mock/Mock";
import "./mock/ApprovalMock";

export const SUPER_THEM_EXAM_FEE_CONFIG_KEY = "superthem.exam.fee";

const EXAM_FEE_CONFIG_NAME = "超级个体笔试费用";
const EXAM_FEE_CONFIG_DESC = "入驻审核笔试申请费用，0表示无需缴纳";

const getExamFee = async (): Promise<string> => {
    if (mock) {
        return getMockData("superthem_exam_fee") ?? "0";
    }
    const configs = await AppConfigApi.getAllConfigs();
    const item = configs.find(config => config.key === SUPER_THEM_EXAM_FEE_CONFIG_KEY);
    return item?.value ?? "0";
};

const setExamFee = async (fee: string): Promise<boolean> => {
    if (mock) {
        return true;
    }
    const configs = await AppConfigApi.getAllConfigs();
    const existing = configs.find(config => config.key === SUPER_THEM_EXAM_FEE_CONFIG_KEY);
    const configItem: AppConfigItem = {
        id: existing?.id ?? "",
        name: EXAM_FEE_CONFIG_NAME,
        key: SUPER_THEM_EXAM_FEE_CONFIG_KEY,
        value: fee,
        description: EXAM_FEE_CONFIG_DESC,
    };
    if (existing?.id) {
        return AppConfigApi.updateConfigItem(configItem);
    }
    const newId = await AppConfigApi.addConfigItem(configItem);
    return newId > 0;
};

const getAllUnprocessed = async (): Promise<Approval[]> => {
    if (mock) {
        return getMockData("audit_unprocessed");
    }
    const resultOrErrorCode = await post<null, Approval[]>("/audit/approval/getAllUnprocessed", null);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

const getAllProcessing = async (): Promise<Approval[]> => {
    if (mock) {
        return getMockData("audit_processing");
    }
    const resultOrErrorCode = await post<null, Approval[]>("/audit/approval/getAllProcessing", null);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

const getAllProcessed = async (): Promise<Approval[]> => {
    if (mock) {
        return getMockData("audit_processed");
    }
    const resultOrErrorCode = await post<null, Approval[]>("/audit/approval/getAllProcessed", null);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

const audit = async (params: ApprovalAuditRequest): Promise<boolean> => {
    if (mock) {
        return true;
    }
    const resultOrErrorCode = await post<ApprovalAuditRequest, boolean>("/audit/approval/audit", params);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return false;
    }
    return resultOrErrorCode;
};

export const ApprovalApi = {
    getAllUnprocessed,
    getAllProcessing,
    getAllProcessed,
    audit,
    getExamFee,
    setExamFee,
}; 